<template>
  <div class="absolute top-0 z-10 h-full w-px bg-sky-400">
    <div
      v-if="showArrow"
      class="absolute z-10 h-0 w-0 origin-bottom-left -translate-x-2 -translate-y-3 rotate-45 border-[5px] border-sky-400"></div>
  </div>
</template>

<script setup>
defineProps({
  showArrow: {
    type: Boolean,
    default: false,
  },
});
</script>
